<div
  class="header"
  [ngClass]="{
    error: params.confirmType === this.confirmEnum.ERROR,
    warning: params.confirmType === this.confirmEnum.WARNING
  }"
>
  <span>{{ params?.title }}</span>
  @if (!params.hideCloseButton) {
    <div class="close-modal" (click)="answer(answerEnum.CLOSE)">&times;</div>
  }
</div>

<div class="content">
  <div
    class="mx-16 my-4 flex flex-col wrap-break-word text-sm font-bold text-smg-darkGray"
    [ngClass]="{ 'max-w-sm': !params.closeButton }"
  >
    {{ params?.message }}
    <div class="mt-8 flex justify-end gap-4">
      @if (params.closeButton) {
        <button class="btn-secondary" (click)="answer(answerEnum.CLOSE)">Annuler</button>
      }
      <button
        class="btn-secondary"
        [ngClass]="{ '!bg-smg-editorOrange': params.closeButton }"
        (click)="answer(answerEnum.FALSE)"
      >
        {{ params.cancelButton ? params.cancelButton : 'Annuler' }}
      </button>
      <button
        class="btn-primary"
        [ngClass]="{ '!bg-smg-lightRed': params.closeButton }"
        (click)="answer(answerEnum.TRUE)"
      >
        {{ params.confirmButton ? params.confirmButton : 'Confirmer' }}
      </button>
    </div>
  </div>
</div>
